module.exports = __webpack_public_path__ + "media/images/procedure_managements/make_payment_task_preview_sm-483b2afe15323f39bb76902e8d6a0b1e.png";